export const TOOLTIP_CLASS_NAME = 'multiSelectTreeElement';
